import React, { useEffect, useMemo, useState } from "react";

import * as S from "./styles";

import Chart from "react-apexcharts";
import {
  CustomChartContainer,
  CustomChartHeader,
  CustomChartTitle,
} from "../styles";
import { CircularProgress } from "@mui/material";

var options = (data) => ({
  chart: {
    // height: 350,
    id: "chart-engajamento",
    type: "line",
    height: 300,
    foreColor: "#000000",
    fontSize: "10px",
    fontFamily: "Inter, Helvetica, Arial, sans-serif",
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
  },
  dataLabels: {
    enabled: true,
    offsetY: -10,
    background: {
      enabled: false,
    },
    style: {
      fontSize: "10px",
      fontFamily: "Inter, Helvetica, Arial, sans-serif",
      // fontWeight: 'bold',
      colors: ["#666666"],
    },
  },
  grid: {
    show: true,
    borderColor: "#ccc",
    strokeDashArray: 0,
    position: "back",
    xaxis: {
      lines: {
        show: false,
      },
    },
    yaxis: {
      lines: {
        show: true,
      },
    },
    row: {
      colors: undefined,
      opacity: 0.5,
    },
    column: {
      colors: undefined,
      opacity: 0.5,
    },
  },
  yaxis: {
    // title: {
    //   text: "$ (thousands)",
    // },
    labels: {
      show: true,
    },
  },
  stroke: {
    curve: "smooth",
    width: 3,
    colors: "#88C54B",
  },
  // resizable: true,
  tooltip: {
    enabled: false,
  },
  legend: {
    showForSingleSeries: true,
    colors: "#88C54B",
    horizontalAlign: "left",
    fontSize: "12px",
    fontFamily: "Poppins, Helvetica, Arial",
    fontWeight: 400,
    labels: {
      colors: "#000000",
      offsetX: 10,
    },
    markers: {
      size: 4,
      shape: undefined,
      strokeWidth: 0,
      fillColors: "#88C54B",
      customHTML: undefined,
      onClick: undefined,
      offsetX: -5,
      offsetY: 0,
    },
    offsetX: 0,
  },
});

const EngajamentoAgentesGraphic = ({ data, isLoadingData }) => {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: 643,
      }}
    >
      <CustomChartContainer>
        <CustomChartHeader>
          <CustomChartTitle>Engajamento dos agentes</CustomChartTitle>
        </CustomChartHeader>
        <S.ChartWrapper id="engajamento-agentes-container">
          {isLoadingData ? (
            <CircularProgress style={{ color: "#F9922A" }} thickness={5} />
          ) : (
            <Chart
              options={{
                ...options(data),
                markers: {
                  size: 3,
                  colors: "#88C54B",
                  strokeColors: "#88C54B",
                  strokeWidth: 3,
                  strokeOpacity: 0.9,
                  strokeDashArray: 0,
                },
                // stroke: {
                //   width: 3,
                //   colors: "#88C54B",
                // },
                xaxis: {
                  categories: data.xaxis.categories,
                },
              }}
              series={data.series}
              width="97%"
              // height={410}
            />
          )}
        </S.ChartWrapper>
      </CustomChartContainer>
    </div>
  );
};

export default EngajamentoAgentesGraphic;
